import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getContragentBadDeleteAvailableColumns } from './api';

export const path = '/contragent-bad/delete/list';

const PageContragentBadDelete: React.FC = (props) => {
  const ContragentBadDelete = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getContragentBadDeleteAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} columns={loaded.columns} />;
    },
  });

  return <ContragentBadDelete {...props} />;
};

export default PageContragentBadDelete;
